module.exports = __webpack_public_path__ + "media/promo/hochland/images/ibg-83fe702e7f46d0af88fd093e98392398.png";